import axios from "../api/axios";

const API_URL = process.env.REACT_APP_API_URL

export interface PromoCode {
    id: number;
    code: string;
    description: string;
    discountPercentage: number;
    isActive: boolean;
}

export const getPromobyCode = async ( id: string ) : Promise<PromoCode> => {
    try {
      const response = await axios(`${API_URL}/promo-code/${id}`);    
      const data = await response.data;
      return data.promoCode as PromoCode;
      
    } catch (error) {
      throw error;
    }
};